import {
  MarketState,
  REQUEST_MARKETS,
  CurrentMarketState,
  REQUEST_CURRENT_MARKET,
  LoginMethodState,
  REQUEST_LOGIN_METHODS
} from "./types";
import { Market } from "../../models/Market";

const initialState: MarketState = {
  markets: []
};

export function marketsReducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_MARKETS:
      return action.payload;
    default:
      return state;
  }
}

const initialCurrentMarketState: CurrentMarketState = {
  market: {} as Market
};

export function currentMarketReducer(
  state = initialCurrentMarketState,
  action: any
) {
  switch (action.type) {
    case REQUEST_CURRENT_MARKET:
      return action.payload;
    default:
      return state;
  }
}

const initialLoginMethodsState: LoginMethodState = {
  loginMethods: []
};

export function loginMethodsReducer(
  state = initialLoginMethodsState,
  action: any
) {
  switch (action.type) {
    case REQUEST_LOGIN_METHODS:
      return action.payload;
    default:
      return state;
  }
}
